/* eslint-disable no-case-declarations */
import { combineReducers } from 'redux';
import {
  CACHE_SIGNALS_LIST,
  FETCH_SIGNALS_LIST_FAILURE,
  FETCH_SIGNALS_LIST_REQUEST,
  FETCH_SIGNALS_LIST_SUCCESS,
  SIGNALS_LIST_CHANGE_COMMON,
  SIGNALS_LIST_CHANGE_DELETE,
  SIGNALS_LIST_CHANGE_DELETE_INIT,
  SIGNALS_LIST_CHANGE_EXPIRY_INIT,
  SIGNALS_LIST_CHANGE_MODAL_ERROR,
  SIGNALS_LIST_CHANGE_RENAME_INIT,
  SIGNALS_LIST_TABLE_MULTI_SELECT,
  SIGNALS_LIST_TABLE_SETTINGS_SAVE_COLUMN_TOGGLE,
  SIGNALS_LIST_TABLE_SHIFT_PRESSED,
  SIGNALS_LIST_TABLE_SORTING,
  UPDATE_SIGNALS_LIST_FILTERS,
} from '../../../constants/ActionTypes';
import storage from '../../../storage';
import { columns } from '../../../partials/Signals/IndexPage/SignalsTable/columns';
import { readBuffer } from '../../../utils';
import { deleteSignalsTableData, updateSignalsTableData } from './updators';

export const COLUMN_TOGGLE_COOKIE = 'signals-list-table-settings-column-toggle';

const getSortFromStorage = () =>
  storage.getItem(SIGNALS_LIST_TABLE_SORTING) || {};

const getFilterFromStorage = () =>
  readBuffer(UPDATE_SIGNALS_LIST_FILTERS) || {};

export function getSignalsListTableColumnToggleCookie() {
  const cookie = storage.getItem(COLUMN_TOGGLE_COOKIE) || {};
  const newCookie = {};

  for (let index = 0; index < columns.length; index++) {
    const column = columns[index];

    if (!column?.meta?.toggle) {
      continue;
    }

    let cookieData = cookie[column.accessor];

    if (cookieData === undefined) {
      // assign default state
      cookieData = column?.meta?.toggleDefaultState || false;
    }

    newCookie[column.accessor] = cookieData;
  }

  return newCookie;
}

function getInintialColumnToggleData() {
  const cookie = getSignalsListTableColumnToggleCookie();
  const toggleColumns = [];

  for (let index = 0; index < columns.length; index++) {
    const column = columns[index];

    if (!column?.meta?.toggle) {
      continue;
    }

    const cookieData = cookie[column.accessor] || false;

    toggleColumns.push({
      name: column.accessor,
      label:
        column.Header && typeof column.Header == 'string'
          ? column.Header
          : column.accessor,
      showColumn: cookieData,
    });
  }

  return toggleColumns;
}

function convertToCookieData(arrayData = []) {
  const toggleColumns = {};

  for (let index = 0; index < arrayData.length; index++) {
    const element = arrayData[index];

    toggleColumns[element.name] = element.showColumn;
  }

  return toggleColumns;
}

const list = (
  state = {
    data: {},
    dataCached: [],
    filters: getFilterFromStorage(),
    isFetching: false,
    error: null,
    updateTime: new Date(),
    cacheUpdateTime: new Date(),
    filtersUpdateTime: new Date(),
    tableSettings: getInintialColumnToggleData(),
    tableSettingsUpdateTime: Date.now(),
    multiSelectSelected: false,
    shiftPressed: false,
    sorting: getSortFromStorage(),
    modalErrors: {
      showError: false,
      error: {},
    },
    renameDataModal: {
      start: false,
      id: '',
      name: '',
    },
    deleteDataModal: {
      start: false,
      id: '',
    },
    expiryDataModal: {
      start: false,
      id: '',
      expiry: undefined,
    },
  },
  action
) => {
  switch (action.type) {
    case FETCH_SIGNALS_LIST_REQUEST:
      return { ...state, isFetching: true, error: null };
    case FETCH_SIGNALS_LIST_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        data: action.data.data,
        updateTime: new Date(),
      };
    case FETCH_SIGNALS_LIST_FAILURE:
      return { ...state, isFetching: false, error: action.error };
    case CACHE_SIGNALS_LIST:
      return { ...state, dataCached: action.data, cacheUpdateTime: new Date() };
    case UPDATE_SIGNALS_LIST_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.data,
        },
        filtersUpdateTime: new Date(),
      };
    case SIGNALS_LIST_TABLE_SETTINGS_SAVE_COLUMN_TOGGLE:
      storage.setItems({
        [COLUMN_TOGGLE_COOKIE]: convertToCookieData(action.data),
      });

      return {
        ...state,
        tableSettingsUpdateTime: Date.now(),
        tableSettings: action.data,
      };
    case SIGNALS_LIST_TABLE_MULTI_SELECT:
      return {
        ...state,
        multiSelectSelected: action.data.id,
      };
    case SIGNALS_LIST_TABLE_SHIFT_PRESSED:
      return {
        ...state,
        shiftPressed: action.data,
      };
    case SIGNALS_LIST_TABLE_SORTING:
      storage.setItems({
        [SIGNALS_LIST_TABLE_SORTING]: action.data,
      });

      return {
        ...state,
        sorting: action.data,
      };
    case SIGNALS_LIST_CHANGE_COMMON:
      const dataSignalsListChangeCommon = updateSignalsTableData(
        state,
        action?.updatedData,
        action?.newDataToInsert
      );

      return {
        ...state,
        data: dataSignalsListChangeCommon,
        dataCached: dataSignalsListChangeCommon.data,
        updateTime: action?.isUpdateDate ? new Date() : state.updateTime,
      };
    case SIGNALS_LIST_CHANGE_DELETE:
      const dataSignalsListChangeDelete = deleteSignalsTableData(
        state,
        action.data.signalIdsToRemove
      );

      return {
        ...state,
        data: dataSignalsListChangeDelete,
        dataCached: dataSignalsListChangeDelete.data,
        updateTime: new Date(),
      };
    case SIGNALS_LIST_CHANGE_MODAL_ERROR:
      return {
        ...state,
        modalErrors: action.data,
      };
    case SIGNALS_LIST_CHANGE_RENAME_INIT:
      return {
        ...state,
        renameDataModal: action.data,
      };
    case SIGNALS_LIST_CHANGE_DELETE_INIT:
      return {
        ...state,
        deleteDataModal: action.data,
      };
    case SIGNALS_LIST_CHANGE_EXPIRY_INIT:
      return {
        ...state,
        expiryDataModal: action.data,
      };
    default:
      return state;
  }
};

const signals = combineReducers({
  list,
});

export default signals;
